var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/DragHandle/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import { DragHandleContainer } from "./styles";
var ComponentKey = "drag-handle";
var DragHandle = function DragHandle(_ref) {
  var className = _ref.className,
    containerProps = _ref.containerProps,
    onPointerDown = _ref.onPointerDown,
    onPointerUp = _ref.onPointerUp;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGrabbing = _useState2[0],
    setIsGrabbing = _useState2[1];
  useEffect(function () {
    if (isGrabbing) {
      var handler = function handler(e) {
        setIsGrabbing(false);
        onPointerUp === null || onPointerUp === void 0 ? void 0 : onPointerUp(e);
      };
      document.addEventListener("pointerup", handler, true);
      return function () {
        return document.removeEventListener("pointerup", handler, true);
      };
    }
  }, [isGrabbing]);
  var onDragHandlePointerDown = function onDragHandlePointerDown(e) {
    setIsGrabbing(true);
    onPointerDown === null || onPointerDown === void 0 ? void 0 : onPointerDown(e);
  };
  return /*#__PURE__*/React.createElement(DragHandleContainer, _extends({
    className: className,
    "data-testid": ComponentKey,
    isGrabbing: isGrabbing,
    handlers: {
      onPointerDown: onDragHandlePointerDown
    }
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("span", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("span", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("span", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }));
};
export default DragHandle;